<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="instamedFormGroup">
  <fieldset>
    <div class="form-group fieldIsRequired">
      <label class="col-md-8 control-label" for="merchantId">
        InstaMed Merchant ID (MID)
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="merchantId"
          [ngClass]="{
            'is-invalid':
              instamedFormGroup.controls.merchantId.invalid &&
              (instamedFormGroup.controls.merchantId.dirty ||
                instamedFormGroup.controls.merchantId.touched)
          }"
          id="merchantId"
        />

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            instamedFormGroup.controls.merchantId.invalid &&
            (instamedFormGroup.controls.merchantId.dirty ||
              instamedFormGroup.controls.merchantId.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="instamedFormGroup.controls.merchantId.errors?.required"
          >
            Field is required.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="hasFinanceRole()">
      <label class="col-md-4 control-label" for="clientId"> Client ID </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="clientId"
          [ngClass]="{
            'is-invalid':
              instamedFormGroup.controls.clientId.invalid &&
              (instamedFormGroup.controls.clientId.dirty ||
                instamedFormGroup.controls.clientId.touched)
          }"
          id="clientId"
        />

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            instamedFormGroup.controls.clientId.invalid &&
            (instamedFormGroup.controls.clientId.dirty ||
              instamedFormGroup.controls.clientId.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="instamedFormGroup.controls.clientId.errors?.maxlength"
          >
            Content is too long. Max length 255.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="hasFinanceRole()">
      <label class="col-md-4 control-label" for="clientSecret">
        Client Secret
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="clientSecret"
          [ngClass]="{
            'is-invalid':
              instamedFormGroup.controls.clientSecret.invalid &&
              (instamedFormGroup.controls.clientSecret.dirty ||
                instamedFormGroup.controls.clientSecret.touched)
          }"
          id="clientSecret"
        />

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            instamedFormGroup.controls.clientSecret.invalid &&
            (instamedFormGroup.controls.clientSecret.dirty ||
              instamedFormGroup.controls.clientSecret.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="instamedFormGroup.controls.clientSecret.errors?.maxlength"
          >
            Content is too long. Max length 255.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group fieldIsRequired">
      <label class="col-md-8 control-label" for="storeId"> Store ID </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="storeId"
          maxlength="4"
          [ngClass]="{
            'is-invalid':
              instamedFormGroup.controls.storeId.invalid &&
              (instamedFormGroup.controls.storeId.dirty ||
                instamedFormGroup.controls.storeId.touched)
          }"
          id="storeId"
        />
        <div
          class="formValidationMessage mt-1"
          *ngIf="
            instamedFormGroup.controls.storeId.invalid &&
            (instamedFormGroup.controls.storeId.dirty ||
              instamedFormGroup.controls.storeId.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="instamedFormGroup.controls.storeId.errors?.required"
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="
              instamedFormGroup.controls.storeId.errors?.pattern ||
              instamedFormGroup.controls.storeId.errors?.maxlength
            "
          >
            Store ID must be exactly 4 numeric digits.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-8 control-label" for="accountId"> Account ID </label>
      <div class="col-md-8">
        <input
          class="form-control"
          type="text"
          formControlName="accountId"
          id="accountId"
        />
      </div>
    </div>
  </fieldset>
  <fieldset class="mt-4">
    <div class="col-12">
      <legend class="mb-3">Terminal Information</legend>
    </div>

    <div formGroupName="terminalInfo">
      <div class="form-group">
        <label class="col-md-8 control-label" for="patientPortal">
          Patient Portal Terminal ID
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                terminalIdGroup.controls.patientPortal.invalid &&
                (terminalIdGroup.controls.patientPortal.dirty ||
                  terminalIdGroup.controls.patientPortal.touched)
            }"
            type="text"
            formControlName="patientPortal"
            maxlength="4"
            id="patientPortal"
          />
          <div
            class="formValidationMessage mt-1"
            *ngIf="
              terminalIdGroup.controls.patientPortal.invalid &&
              (terminalIdGroup.controls.patientPortal.dirty ||
                terminalIdGroup.controls.patientPortal.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                terminalIdGroup.controls.patientPortal.errors?.pattern ||
                terminalIdGroup.controls.patientPortal.errors?.maxlength
              "
            >
              Terminal ID must be exactly 4 numeric digits.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-8 control-label" for="virtualVisits">
          Virtual Visits Terminal ID
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            formControlName="virtualVisits"
            maxlength="4"
            [ngClass]="{
              'is-invalid':
                terminalIdGroup.controls.virtualVisits.invalid &&
                (terminalIdGroup.controls.virtualVisits.dirty ||
                  terminalIdGroup.controls.virtualVisits.touched)
            }"
            id="virtualVisits"
          />
          <div
            class="formValidationMessage mt-1"
            *ngIf="
              terminalIdGroup.controls.virtualVisits.invalid &&
              (terminalIdGroup.controls.virtualVisits.dirty ||
                terminalIdGroup.controls.virtualVisits.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                terminalIdGroup.controls.virtualVisits.errors?.pattern ||
                terminalIdGroup.controls.virtualVisits.errors?.maxlength
              "
            >
              Terminal ID must be exactly 4 numeric digits.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-8 control-label" for="engage">
          Engage Terminal ID
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                terminalIdGroup.controls.engage.invalid &&
                (terminalIdGroup.controls.engage.dirty ||
                  terminalIdGroup.controls.engage.touched)
            }"
            type="text"
            formControlName="engage"
            maxlength="4"
            id="engage"
          />
          <div
            class="formValidationMessage mt-1"
            *ngIf="
              terminalIdGroup.controls.engage.invalid &&
              (terminalIdGroup.controls.engage.dirty ||
                terminalIdGroup.controls.engage.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                terminalIdGroup.controls.engage.errors?.pattern ||
                terminalIdGroup.controls.engage.errors?.maxlength
              "
            >
              Terminal ID must be exactly 4 numeric digits.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 ml-3">
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              terminalIdGroup.errors?.required &&
              (terminalIdGroup.dirty || terminalIdGroup.touched)
            "
          >
            <div>You must enter at least one Terminal ID</div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
